import Title from '@/components/ui/Title'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'

const RussianVillage = () => {
  return (
    <div className="py-4 px-8 flex flex-col gap-8">
      <Title className="w-full text-center" text="Medieval Russian Project" />
      <p className="text-3xl leading-12 md:px-16">
        The aim for this project was to create a virtual game environment in
        Unreal Engine with full set dressing and attention to lighting/post
        production. The idea for this area would be a resting/camp zone for a
        hypothetical game. An RPG set in a medieval Russian landscape, with an
        emphasis on Russian folklore and mythology, this zone would be a safe
        haven for the player to rest, recuperate and restore resources. It will
        be summoned when needed, and within the player can find an armory,
        traditional Russian oven for cooking, a potions table, storage and a
        transformation mirror. Within the oven resides the caretaker spirit of
        the house, the “Domovoy”. Depending on how the player treats the Domovoy
        will determine how stocked the house is and how well rested the player
        is after visiting.
      </p>
      <div className="flex-row justify-center flex">
        <iframe
          className="aspect-video w-full md:w-[75%]"
          title="Medieval Russian Project"
          src="https://www.youtube.com/embed/yg6ay4f_ImI"
        />
      </div>
      <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}>
        <Masonry>
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/RussianVillage/house1.webp"
            alt="House 1"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/RussianVillage/house2.webp"
            alt="House 2"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/RussianVillage/house3.webp"
            alt="House 3"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/RussianVillage/house4.webp"
            alt="House 4"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/RussianVillage/house5.webp"
            alt="House 5"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/RussianVillage/house6.webp"
            alt="House 6"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/RussianVillage/house7.webp"
            alt="House 7"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/RussianVillage/house8.webp"
            alt="House 8"
          />
        </Masonry>
      </ResponsiveMasonry>
    </div>
  )
}

export default RussianVillage
